<template>
  <div class="areamap-container">
    <div class="amap-page-container">
      <div class="input-search">
        <el-input v-model="address" class="input-address" :placeholder="$t('gis.please_search_address')"></el-input>
        <el-button icon="el-icon-search" class="btn-search" @click="searchMap()" size="medium"/>
      </div>
      <el-amap vid="areamap" class="amap-demo" mapStyle="amap://styles/light" :center="center" :zoom="zoom" :events="events">
        <!-- 点击显示标记 -->
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="marker.index"
          :position="marker.position"
          :icon="marker.icon"
          :title="marker.title"
          :events="marker.events"
          :visible="marker.visible"
          :draggable="marker.draggable"
          :vid="index"
        />
      </el-amap>
    </div>
  </div>
</template>
<script>
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  name: 'AddMap',
  props: ['nowlng', 'nowlat'],
  data() {
    const self = this
    return {
      map: {
        lng: null,
        lat: null
      },
      // 地图相关
      address: '', // 获取的位置
      zoom: 15, // 地图缩放
      center: [], // 初始中心
      lng: null, // 经纬度
      lat: null,
      loaded: false,
      markers: [{ position: [] }], // 点击显示的标记默认的定位
      // 点击地图获取当前位置并显示标记
      events: {
        click(e) {
          self.chaadd(e.lnglat)
        }
      }
    }
  },
  computed: {
    nowLnglat() {
      const lng = this.nowlng
      const lat = this.nowlat
      return { lng, lat }
    }
  },
  watch: {
    nowLnglat: {
      handler: function(newVal, oldVal) {
        if (oldVal.lng && newVal.lng && newVal.lat) {
          this.chaadd(newVal)
        }
      }
    }
  },
  async created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.map.lng = mapData.center[0]
    this.map.lat = mapData.center[1]

    this.center = mapData.center
    this.lng = mapData.center[0]
    this.lat = mapData.center[1]

    this.markers[0].position = mapData.center

    const lng = this.nowlng
    const lat = this.nowlat
    if (lng && lat) {
      await this.chaadd({
        lng,
        lat
      })
    }
  },
  methods: {
    searchMap() {
      const that = this
      const address = this.address
      var geocoder = new window.AMap.Geocoder({
        city: '全国'
      })
      geocoder.getLocation(address, function(status, result) {
        if (status === 'complete' && result.geocodes.length) {
          var lnglat = result.geocodes[0].location
          that.center = [lnglat.lng, lnglat.lat]
          that.lng = lnglat.lng
          that.lat = lnglat.lat
          that.markers = [{
            position: that.center
          }]
          that.map.lng = that.lng
          that.map.lat = that.lat

          that.$emit('mapDing', that.map)
        } else {
          that.address = ''
          that.lng = null
          that.lat = null
          that.$message({
            type: 'error',
            message: this.$t('gis.please_hand')
          })
        }
      })
      
    },
    chaadd(e) {
      const self = this
      const { lng, lat } = e
      self.lng = lng
      self.lat = lat
      self.map.lng = self.lng
      self.map.lat = self.lat
      self.center = [self.lng, self.lat]
      self.loaded = true
      self.markers = [{ position: self.center }]
      self.$emit('mapDing', self.map)
    }
  }
}
</script>
<style lang="less">
@color-primary:#0c82fe;
.areamap-container{
  height: 325px;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  .amap-page-container {
    height: 325px;
    width: 100%;
    position: relative;
    .input-search {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 5;
      width: 320px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 99999999999;
      .input-address{
        width: 272px !important;
        .el-input__inner{
          background-color: #fff !important;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: 0 !important;
        }
      }
      .btn-search{
        box-sizing: border-box;
        height: 40px;
        width: 50px;
        background: @color-primary !important;
        border-color: @color-primary !important;
        color:#fff !important;
        display: flex;
        padding: 0 !important;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 0;
         border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
